import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=1ff412f0&scoped=true"
import script from "./OfferPage.vue?vue&type=script&lang=js"
export * from "./OfferPage.vue?vue&type=script&lang=js"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=1ff412f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff412f0",
  null
  
)

export default component.exports